import { Component } from '@angular/core';
import { FormControl } from '@angular/forms';

import { DefaultEditor } from './default-editor';

@Component({
  selector: 'select-editor',
  template: `
    <select [ngClass]="inputClass" class="form-control" [formControl]="formControl" [name]="cell.getId()"
      (click)="onClick.emit($event)" (keydown.enter)="onEdited.emit($event)" (keydown.esc)="onStopEditing.emit()">
      <option value="">Select...</option>
      @for (option of getList(); track option) {
        <option [value]="option.value" [selected]="option.value === cell.getValue()">
          {{ option.title }}
        </option>
      }
    </select>
  `,
  standalone: false
})
export class SelectEditorComponent extends DefaultEditor {
  get formControl(): FormControl {
    return this.cell.getValidator() as FormControl;
  }

  getList(): any[] {
    return this.cell.getColumn().getConfig()?.list || [];
  }

  constructor() {
    super();
  }
}
